import { FC } from 'react'
import Pagination from '../models/Pagination'
import { useHistory } from 'react-router-dom'
import { TablePagination } from '@mui/material'

interface PaginationProps {
  pagination?: Pagination
  changePage?: ( page: number ) => void
}

const PaginationButtons: FC<PaginationProps> = ({ pagination, changePage }) => {
  const history = useHistory()
  
  const handleChangePage = (page: number) => {
    const urlSearch = new URLSearchParams(history.location.search)
    urlSearch.set('page', page.toString())
    history.push({ search: urlSearch.toString() })
  }
  
  if (!pagination) return <></>
  return <TablePagination
    component="div"
    page={pagination.page}
    count={pagination.count}
    rowsPerPage={pagination.size}
    rowsPerPageOptions={[pagination.size]}
    onPageChange={(mouseEvent, page) => { mouseEvent?.stopPropagation(); mouseEvent?.preventDefault(); changePage ? changePage(page) : handleChangePage(page) }}
    labelDisplayedRows={info => `${info.from}-${info.to} de ${info.count}`}
  />
}

export default PaginationButtons